import { Injectable, PLATFORM_ID, inject } from "@angular/core";

import { Action, Selector, State, StateContext, Store } from "@ngxs/store";
import { tap } from "rxjs";

import { ICategory } from "../../shared/interface/category.interface";
import {
  GetCategoriesAction,
  GetLayerdCategoriesWithProductsAction,
} from "../action/category.action";
import { CategoryService } from "../services/category.service";
import { IApiResponse } from "../interface/api-response.interface";
import { ThemeOptionService } from "../services/theme-option.service";
import { Router } from "node_modules/@angular/router/types/_router_module-chunk";

export class CategoryStateModel {
  category = {
    data: [] as ICategory[],
    total: 0,
  };
  categoryWithProducts: any[] | [];
}

@State<CategoryStateModel>({
  name: "category",
  defaults: {
    category: {
      data: [],
      total: 0,
    },
    categoryWithProducts: [],
  },
})
@Injectable()
export class CategoryState {
  private themeOptionService = inject(ThemeOptionService);
  private categoryService = inject(CategoryService);

  @Selector()
  static category(state: CategoryStateModel) {
    return state.category;
  }

  @Selector()
  static categoryWithProducts(state: CategoryStateModel) {
    return state.categoryWithProducts;
  }

  // @Action(GetCategoriesAction)
  // getCategories(
  //   ctx: StateContext<CategoryStateModel>,
  //   action: GetCategoriesAction,
  // ) {
  //   return this.categoryService.getCategories(action.payload).pipe(
  //     tap({
  //       next: (result) => {
  //         ctx.patchState({
  //           category: {
  //             data: result.data,
  //             total: result?.total ? result?.total : result?.data?.length,
  //           },
  //         });
  //       },
  //       error: (err) => {
  //         throw new Error(err?.error?.message);
  //       },
  //     }),
  //   );
  // }
  @Action(GetCategoriesAction)
  getCategories(ctx: StateContext<CategoryStateModel>) {
    return this.categoryService.getAll().pipe(
      tap({
        next: (result: IApiResponse) => {
          ctx.patchState({
            category: {
              data: result.data,
              total: result.data.length,
            },
          });
        },
        error: (err) => {
          console.error(err);
        },
      })
    );
  }

  @Action(GetLayerdCategoriesWithProductsAction)
  getLayerdCategoriesWithProducts(
    ctx: StateContext<CategoryStateModel>,
    action: GetLayerdCategoriesWithProductsAction
  ) {
    this.themeOptionService.preloader = true;
    return this.categoryService.LayerdCategoriesWithProducts().pipe(
      tap({
        next: (result) => {
          ctx.patchState({
            categoryWithProducts: result.data,
          });
        },
        complete: () => {
          this.themeOptionService.preloader = false;
        },
        error: (err) => {
          throw new Error(err?.error?.message);
        },
      })
    );
  }
}
